import { styles } from "./ToggleSwitch.style";

export interface ToggleSwitchProps {
  toggleSwitchLabel: string;
  toggleSwitchOnLabel: string;
  toggleSwitchOffLabel: string;
  active: boolean;
  onClick: () => void;
}

export const ToggleSwitch = (props: ToggleSwitchProps) => {
  const { toggleSwitchLabel, toggleSwitchOnLabel, toggleSwitchOffLabel, active, onClick } = props;

  return (
    <div className={styles.root()}>
      {toggleSwitchLabel && <span className={styles.label()}>{toggleSwitchLabel}</span>}
      {toggleSwitchOffLabel && <span className={styles.sideLabel(!active)}>{toggleSwitchOffLabel}</span>}
      <button
        type="button"
        role="switch"
        aria-checked={active}
        aria-label={toggleSwitchLabel}
        className={styles.track(active)}
        onClick={onClick}
      >
        <span className={styles.thumb(active)} />
      </button>
      {toggleSwitchOnLabel && <span className={styles.sideLabel(active)}>{toggleSwitchOnLabel}</span>}
    </div>
  );
};
